import axios, { AxiosInstance, AxiosError } from 'axios';
import { API_URL } from '../../constants';

// Create axios instance with default config
const apiClient: AxiosInstance = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
    'token': localStorage.getItem('token') || ''
  },
  // withCredentials: true,
});

// Add response interceptor for error handling
apiClient.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      try {
        console.error('API Error:', error.response.data);
      } catch (consoleError) {
        console.error('API Error (data access failed):', consoleError);
        console.error('Raw error response:', error.response);
      }
      try {
        if (error.response?.status === 401) {
          // Preserve deep link before clearing storage
          const deepLinkUrl = localStorage.getItem('deepLinkUrl');

          localStorage.clear();
          sessionStorage.clear();
          
          // Restore deep link if it existed
          if (deepLinkUrl) {
            localStorage.setItem('deepLinkUrl', deepLinkUrl);
          }
          
          // Redirect to signin page
          window.location.href = '/signin';
        }
        return Promise.reject(error.response.data);
      } catch (rejectError) {
        console.error('Reject error (data access failed):', rejectError);
        return Promise.reject(error.response || error);
      }
    } else if (error.request) {
      // The request was made but no response was received
      console.error('Network Error:', error.stack);
      return Promise.reject(new Error('Network Error - No response received'));
    } else {
      // Something happened in setting up the request that triggered an Error
      console.error('Request Error:', error.message);
      return Promise.reject(error);
    }
  }
);

// Add request interceptor for logging
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers = config.headers || {};
      config.headers['token'] = token;
    }
    return config;
  },
  (error) => {
    console.error('Request Error:', error);
    return Promise.reject(error);
  }
);

// Helper function to get signed URL for avatar upload
export const getSignedUrl = async (fileName: string) => {
  const response = await apiClient.post('user/avatar/upload-url', {
    fileName: fileName, // Get file extension
  });
  return response.data;
};

export default apiClient; 